import React, {useState} from 'react';
import {Listbox} from "@headlessui/react";
import clsx from "clsx";
import {ArrowDown} from "../icons";
const Select = (
  { value, activeData, onChange, className, error }:
  { value?: Array<any>; activeData?: any; className?: string; onChange: (data: string) => void; error?: string | boolean }
) => {

  return (
    <div className="relative">
      <Listbox value={!!activeData ? activeData?.id : ''} defaultValue={''} onChange={(e) => onChange(e)}>
        <Listbox.Button as={React.Fragment}>{({ open }) => (
          <button
            className={
              clsx(
          "min-h-[32px] relative flex items-center border-gray justify-between bg-white w-full py-[7px] px-2 border rounded-[2px] text-left duration-150 ease-in",
                className
              )
            }>
            <p className="text-xs text-black">{activeData?.label}</p>
            <ArrowDown />
          </button>
        )}</Listbox.Button>
        {error && <span className="absolute bottom-[-15px] text-rose-700 text-xs">{error}</span>}
        <Listbox.Options className="absolute max-h-[250px] overflow-y-scroll z-50 right-0 left-0 drop-shadow bg-white rounded-[2px] text-black duration-150 ease-in">
          {value?.map(v => (
            <Listbox.Option
              key={v.id}
              value={v.id}
              className="py-1 px-2 text-xs cursor-pointer duration-150 rounded-[2px] text-black ease-in hover:bg-gray"
            >
              {v.label}
            </Listbox.Option>
          ))}
        </Listbox.Options>
      </Listbox>
    </div>
  )
};

export default Select;
